import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-foldersimpleminus",
  "use": "icon-th-foldersimpleminus-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-foldersimpleminus\">\n<path d=\"M20 18C20 18.2652 19.8946 18.5196 19.7071 18.7071C19.5196 18.8946 19.2652 19 19 19H13C12.7348 19 12.4804 18.8946 12.2929 18.7071C12.1054 18.5196 12 18.2652 12 18C12 17.7348 12.1054 17.4804 12.2929 17.2929C12.4804 17.1054 12.7348 17 13 17H19C19.2652 17 19.5196 17.1054 19.7071 17.2929C19.8946 17.4804 20 17.7348 20 18ZM29 11V25.1112C28.9993 25.612 28.8001 26.092 28.4461 26.4461C28.092 26.8001 27.612 26.9993 27.1112 27H5C4.46957 27 3.96086 26.7893 3.58579 26.4142C3.21071 26.0391 3 25.5304 3 25V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11.6663C12.0988 6.00107 12.5196 6.14132 12.8663 6.4L16.3337 9H27C27.5304 9 28.0391 9.21071 28.4142 9.58579C28.7893 9.96086 29 10.4696 29 11ZM27 11H16.3337C15.9012 10.9989 15.4804 10.8587 15.1337 10.6L11.6663 8H5V25H27V11Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-foldersimpleminus.svg
// module id = jR71
// module chunks = 84